import { getOperationName } from '../../../../../common/utils/operation';
import { ACTIVITY_FILTER_COLLECTION } from '../../../activity-filters';
var ACTIVITIES = "\n  nodes {\n    id\n    timestamp\n    object {\n      id\n      name\n      cloudId\n      localResourceId\n      product\n      type\n      url\n      iconUrl\n      containers {\n        name\n      }\n      contributors {\n        profile {\n          accountId\n          name\n          picture\n        }\n      }\n      events {\n        eventType\n      }\n      extension {\n        ... on ActivitiesJiraIssue {\n          issueKey\n        }\n      }\n    }\n  }\n";
var WORKED_ON_QUERY = "\n   workedOn(first: $first, filters: $filters) {\n     ".concat(ACTIVITIES, "\n   }\n");
var VIEWED__QUERY = "\n   viewed(first: $first, filters: $filters) {\n     ".concat(ACTIVITIES, "\n   }\n");
var ALL__QUERY = "\n    all(first: $first, filters: $filters) {\n      ".concat(ACTIVITIES, "\n    }\n");
var activityQueryMap = new Map([['workedOn', WORKED_ON_QUERY], ['viewed', VIEWED__QUERY], ['all', ALL__QUERY]]);
var getMyActivitiesQuery = function getMyActivitiesQuery(queries) {
  return "\n      myActivities {\n        ".concat(queries.join('\n'), "\n      }\n");
};
var getActivitiesQuery = function getActivitiesQuery(product, content) {
  return "\n    query ".concat(getOperationName(product), "($first: Int, $filters: [ActivitiesFilter!]) {\n      activities {\n        ").concat(content, "\n      }\n    }\n");
};
export var generateActivityQueryWithFilters = function generateActivityQueryWithFilters(product, filters, activityQueries) {
  /**
   * If we are filtering by `accountIds` then we can't use the `myActivity` query.
   */
  if (Array.isArray(filters.actors)) {
    // you can't view `viewed` events for other accounts
    var filteredAccountQueries = activityQueries.filter(function (query) {
      return query !== 'viewed';
    });
    return {
      query: getActivitiesQuery(product, filteredAccountQueries.map(function (query) {
        return activityQueryMap.get(query);
      }).join('\n')),
      queryFilters: ACTIVITY_FILTER_COLLECTION.v2.get('activities')(filters)
    };
  } else {
    return {
      query: getActivitiesQuery(product, getMyActivitiesQuery(activityQueries.map(function (query) {
        return activityQueryMap.get(query);
      }))),
      queryFilters: ACTIVITY_FILTER_COLLECTION.v2.get('myActivity')(filters)
    };
  }
};